import React, { useEffect } from "react";
import { useState } from "react";
import { Collapse } from "reactstrap";
import styled from "styled-components";
import Toggle from "../../../../core/components/CollapsToggle/Toggle";
import { InputField1 } from "../../../InputField1/InputField1";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";
import Typography from "../../../Typography/Typography";
import { RowElement, RowLayoutStyle } from "../../Sliders/AddSlide";
import { HiArrowCircleDown } from "react-icons/hi";
import { errorMessage } from "../../../../utils/message";
import Spinner from "react-bootstrap/Spinner";
import Editor from "../../../../core/components/textEditor/Editor";

import {
  useGetBrandList,
  useGetGenderList,
  useGetAllBrand,
  useGetInventoryList,
} from "../../../../hooks/useContent";

// textEditor={textEditor}
// setTextEditor={setTextEditor}
// entextEditor={entextEditor}
// setEnTextEditor={setEnTextEditor}
// artextEditor={artextEditor}
// setArTextEditor={setArTextEditor}

function DetailProduct({
  handleChange,
  form,
  textEditor,
  setTextEditor,
  entextEditor,
  setEnTextEditor,
  artextEditor,
  setArTextEditor,
  handleChangeSelect,
}) {
  const selectOptions = [];
  const [showEn, setShowEn] = useState(false);
  const [showAr, setShowAr] = useState(false);
  const [textEdi, setTextEdi] = useState("");

  const {
    data: brandList,
    isLoading: loadingBrand,
    isError: brandError,
    isFetching: isBrandFetch,
  } = useGetBrandList();

  const { data: brandListAll, isLoading: loadingBrandList } = useGetAllBrand();

  const {
    data: genderList,
    isLoading: genderLoading,
    isFetching: isGenderFetch,
    error: genderError,
  } = useGetGenderList();

  const {
    data: inventoryList,
    isLoading: inventoryLoading,
    error: inventoryError,
    isFetching: isInventoryFetch,
  } = useGetInventoryList();

  let brandOption = brandListAll?.data?.brands?.map((brand) => {
    return {
      value: brand?.IdBrands,
      label: brand?.NameBrands,
    };
  });

  let GenderOption = genderList?.pages[0]?.data?.Genders?.map((gender) => {
    return {
      value: gender?.IdGenders,
      label: gender?.Gender,
    };
  });

  let inventoryListOption = inventoryList?.data?.WarehouseTypes?.map(
    (inventor) => {
      return {
        value: inventor?.IdWarehouseTypes,
        label: inventor?.NameWarehouse,
      };
    }
  );

  const brandDetaultOption = {
    value: -1,
    label: "برند را انتخاب کنید",
  };

  const genderDetaultOption = {
    value: -1,
    label: "جنسیت را انتخاب کنید",
  };

  const inventorDetaultOption = {
    value: -1,
    label: "انبار را انتخاب کنید",
  };

  brandOption?.unshift(brandDetaultOption);
  GenderOption?.unshift(genderDetaultOption);
  inventoryListOption?.unshift(inventorDetaultOption);

  const inventoryStatusOption = [
    {
      label: "موجود در انبار",
      value: "موجود در انبار",
    },
    {
      label: "عدم موجودی",
      value: "عدم موجودی",
    },
    {
      label: "پیش خرید",
      value: "پیش خرید",
    },
  ];

  // useEffect(() => {

  // }, [textEdi]);

  return (
    <DetailStyle>
      <DetailWrapper>
        <RowLayoutStyle>
          <RowElement>
            <InputField1
              type="text"
              name="nameProduct"
              label="نام محصول"
              value={form?.nameProduct}
              onChange={handleChange}
              placeholder="نام محصول"
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="EnNameProducts"
              label="نام انگلیسی"
              value={form?.EnNameProducts}
              onChange={handleChange}
              placeholder="نام محصول"
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="ArNameProducts"
              label="نام عربی"
              value={form.ArNameProducts}
              onChange={handleChange}
              placeholder="نام محصول"
              maxLenght="50"
            />
          </RowElement>
        </RowLayoutStyle>
        <RowDiv>
          <ColumnDiv>
            {isBrandFetch ? (
              <Spinner animation="border" size="sm" />
            ) : brandError ? (
              <Typography primary={"red"}>
                مشکلی در گرفتن اطلاعات پیش امده
              </Typography>
            ) : (
              <SimpleSelect1
                name={"IdBrand"}
                label={"برند"}
                onChange={(e) => handleChangeSelect(e, "IdBrand")}
                placeholder={"برند را انتخاب کنید"}
                res={brandOption}
              />
            )}
          </ColumnDiv>

          <ColumnDiv>
            {isGenderFetch ? (
              <Spinner animation="border" size="sm" />
            ) : brandError ? (
              <Typography primary={"red"}>
                مشکلی در گرفتن اطلاعات پیش امده
              </Typography>
            ) : (
              <SimpleSelect1
                name={"IdGender"}
                label={"جنسیت"}
                onChange={(e) => handleChangeSelect(e, "IdGender")}
                placeholder={"جنسیت را انتخاب کنید"}
                res={GenderOption}
              />
            )}
          </ColumnDiv>

          <ColumnDiv>
            {isInventoryFetch ? (
              <Spinner animation="border" size="sm" />
            ) : brandError ? (
              <Typography primary={"red"}>
                مشکلی در گرفتن اطلاعات پیش امده
              </Typography>
            ) : (
              <SimpleSelect1
                name={"IdStore"}
                label={"انبار"}
                onChange={(e) => handleChangeSelect(e, "IdStore")}
                placeholder={"انبار را انتخاب کنید"}
                res={inventoryListOption}
              />
            )}
          </ColumnDiv>

          <ColumnDiv>
            <SimpleSelect1
              name={"InventoryStatus"}
              label={"وضعیت در انبار"}
              onChange={(e) => handleChangeSelect(e, "InventoryStatus")}
              placeholder={"موجود در انبار"}
              res={inventoryStatusOption}
            />
          </ColumnDiv>
        </RowDiv>
        <RichTextEditorStyle>
          <Editor state={textEditor} setState={setTextEditor} />
        </RichTextEditorStyle>
        <RichTextEditorStyle>
          <div
            className="title"
            onClick={(e) => setShowEn((before) => !before)}
          >
            <Typography>محتوای انگلیسی</Typography>
            <HiArrowCircleDown size={"25px"} />
          </div>
          <Collapse isOpen={showEn}>
            <EditorContainer>
              <Editor state={entextEditor} setState={setEnTextEditor} />
            </EditorContainer>
          </Collapse>
        </RichTextEditorStyle>
        <RichTextEditorStyle>
          <div
            className="title"
            onClick={(e) => setShowAr((before) => !before)}
          >
            <Typography>محتوای عربی</Typography>
            <HiArrowCircleDown size={"25px"} />
          </div>
          <Collapse isOpen={showAr}>
            <EditorContainer>
              <Editor state={artextEditor} setState={setArTextEditor} />
            </EditorContainer>
          </Collapse>
        </RichTextEditorStyle>
      </DetailWrapper>
    </DetailStyle>
  );
}

const DetailStyle = styled.div`
  background-color: ${({ theme }) => theme.backgroundSidebar};
  width: 100%;
  position: relative;
`;

const DetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.backgroundSidebar};
  position: relatives;

  /* .Collapse {
    z-index: 100;
  } */
`;

const RichTextEditorStyle = styled.div`
  /* display: flex;
  flex-direction: column; */
  cursor: pointer;
  margin-bottom: 1rem;
  position: relative;

  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #647885;
  .title {
    padding: 0 2rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;

export const RowDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  column-gap: 2rem;
  row-gap: 2rem;
  margin-bottom: 2rem;
`;

const EditorContainer = styled.div`
  padding: 1rem 0;
  position: relative;
  z-index: 1;
`;

export const ColumnDiv = styled.div`
  width: 40%;

  @media screen and (max-width: 1100px) {
    width: 100%;
  }
`;

export default DetailProduct;
